import Arrow from "@/common/icons/arrow"
import styles from "./files.module.css"

export default function File({ block }) {
  const { attrs } = block

  if (!attrs?.url || !attrs.text) {
    return null
  }

  return (
    <li className={styles.file} key={attrs.url}>
      <div className="icon">
        <Arrow />
      </div>
      <div>
        <a href={attrs.url} target="_blank" rel="noreferrer">
          {attrs.text}
        </a>
        <span>
          {[attrs?.type.toUpperCase(), attrs?.size].filter(Boolean).join(", ")}
        </span>
      </div>
    </li>
  )
}
